// File: cgp-snackbar.module.ts
// Author: Joseph M Diaz
// Date: 5/4/2017
// Desc: CGP Snackbar component.
// Other Contributors:

import { NgModule } from '@angular/core';

import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { CgpSnackbarService } from './cgp-snackbar.service';

@NgModule({
    imports: [ MatSnackBarModule ],
    providers: [
        CgpSnackbarService
    ]
})
export class CgpSnackbarModule { }